import React, { useState } from 'react';
import './CallButton.css';

const CallButton = ({ mobile, customerName }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const validatePhone = (phone) => {
    if (!phone) return false;
    // Strip non-numeric/non-plus characters and check length
    const cleanPhone = phone.replace(/[^0-9+]/g, '');
    return cleanPhone.length >= 8;
  };

  const handleCallClick = (e) => {
    e.stopPropagation(); // Stop row click events from opening details
    if (!mobile) {
      alert('Customer mobile number is not available.');
      return;
    }
    if (!validatePhone(mobile)) {
      alert('Customer mobile number is invalid.');
      return;
    }
    setShowConfirm(true);
  };

  const executeCall = () => {
    setShowConfirm(false);
    
    // Future-ready placeholder for Cloud Telephony APIs (Twilio, Exotel, etc.)
    // example: cloudCallAPI.initiate({ mobile, customerName });

    window.location.href = `tel:${mobile}`;
  };

  return (
    <>
      <button 
        type="button" 
        className="btn-call-action" 
        onClick={handleCallClick}
        title="Call Customer"
      >
        📞
      </button>

      {showConfirm && (
        <div className="call-modal-overlay" onClick={(e) => { e.stopPropagation(); setShowConfirm(false); }}>
          <div className="call-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="call-modal-header">
              <h3>Call Customer</h3>
              <button className="call-close-btn" onClick={() => setShowConfirm(false)}>×</button>
            </div>
            <div className="call-modal-body">
              <div className="call-avatar">📞</div>
              <div className="call-details">
                <p className="call-label">Customer Name</p>
                <p className="call-value">{customerName}</p>
                
                <p className="call-label">Mobile Number</p>
                <p className="call-value">{mobile}</p>
              </div>
            </div>
            <div className="call-modal-footer">
              <button className="call-btn call-btn-cancel" onClick={() => setShowConfirm(false)}>
                Cancel
              </button>
              <button className="call-btn call-btn-confirm" onClick={executeCall}>
                Call Now
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CallButton;
